import { StudentStudyStore } from './student-study/studentStudy.models';

export const PERSIST_KEY = 'globalAppState';

export const reduxStateDomains = {
  ROUTER_STATE: 'router', // TODO: See if we can safely change this name
  STUDENTSTUDY_STATE: 'studentStudyState',
};

export interface RootState {
  'router': History;
  'studentStudyState': StudentStudyStore;
}

export const restoreStateKeys: Record<keyof StudentStudyStore, boolean> = {
  userHistory: true,
  userHistoryStateCompletedRequests: true,
  courseSectionId: true,
  currentCourse: true,
  allUserCourseSections: true,
  errors: true,
  isbns: true,
  vantageIsbns: true,
  primaryTaxonomies: true,
  isCourseOwner: true,
  linkData: true,
  messages: true,
  pendingRequestCount: false,
  roleId: true,
  userCourseOwnerRecords: true,
  userId: true,
  users: true,
  taxonomies: true,
  assignments: false,
  assessmentSubmissionsMap: true,
  externalEntities: true,
  crosswalkUsers: false,
  // Items below here were added on the assumption they were missed by accident
  evolveUser: true,
  featureFlagsGrouped: true,
  eolsUser: true,
  assessmentStartTimeMap: true,
  appLinkCookies: true,
  collapsedFolderIds: true,
  userEngagementReport: true,
  moduleSequenceMap: true,
  assessments: true,
  enableDeepLink: true,
  groupActivity: true,
  registeredToken: true,
  abTestFlavors: true,
  studentStudyDto: true,
  assessmentPerformanceDetailDto: true,
  osmosisTokenDto: true,
  ecrId: true,
  availableNumberOfQuestions: true,
  questionCountByTopic: true
};

// Anything we do not plan to restore later can be skipped on storage in the first place
export const omitStateKeys: Partial<Record<keyof StudentStudyStore, boolean>> = Object.keys(restoreStateKeys).reduce((acc, key) => {
  if (restoreStateKeys[key]) {
    return acc;
  }
  return {
    ...acc,
    [key]: true
  };
}, {});
